<div class="rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden" id="prompt_diff">
  <!-- Column headers -->
  <div class="grid grid-cols-2 text-[10px] font-semibold uppercase tracking-wider border-b border-slate-200 dark:border-slate-700">
    <div class="px-3 py-2 bg-red-50/60 dark:bg-red-900/10 text-red-500 dark:text-red-400 border-r border-slate-200 dark:border-slate-700">
      {{ oldLabel }}
    </div>
    <div class="px-3 py-2 bg-emerald-50/60 dark:bg-emerald-900/10 text-emerald-600 dark:text-emerald-400">
      {{ newLabel }}
    </div>
  </div>

  <p *ngIf="!changedRows()" class="px-3 py-4 text-xs text-slate-400 text-center" id="prompt_diff_identical">
    No differences — the texts are identical.
  </p>

  <div class="max-h-[55vh] overflow-y-auto font-mono text-[11px] leading-relaxed">
    <ng-container *ngFor="let block of blocks(); let bi = index">
      <!-- Collapsed unchanged run -->
      <button
        *ngIf="block.collapsible && !isExpanded(bi)"
        type="button"
        (click)="toggle(bi)"
        class="w-full px-3 py-1.5 text-[10px] text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-800/40
               hover:text-slate-600 dark:hover:text-slate-300 transition-colors text-center"
      >
        ⋯ {{ block.rows.length }} unchanged lines — click to expand
      </button>

      <ng-container *ngIf="!block.collapsible || isExpanded(bi)">
        <div *ngFor="let row of block.rows" class="grid grid-cols-2">
          <div
            class="px-3 whitespace-pre-wrap break-words border-r border-slate-100 dark:border-slate-700/50"
            [ngClass]="{
              'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300': row.type === 'changed' || row.type === 'removed',
              'text-slate-600 dark:text-slate-300': row.type === 'same',
              'bg-slate-50/60 dark:bg-slate-800/30': row.left === null
            }"
          >{{ row.left ?? '' }}</div>
          <div
            class="px-3 whitespace-pre-wrap break-words"
            [ngClass]="{
              'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300': row.type === 'changed' || row.type === 'added',
              'text-slate-600 dark:text-slate-300': row.type === 'same',
              'bg-slate-50/60 dark:bg-slate-800/30': row.right === null
            }"
          >{{ row.right ?? '' }}</div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
